<template>
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.75 18.75C26.75 12.9688 22.3662 8.19875 16.75 7.57375V5H14.25V7.57375C8.63375 8.19875 4.25 12.9688 4.25 18.75V21.25H26.75V18.75ZM3 22.5H28V25H3V22.5Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'BxsDish',
} as DefineComponent
</script>
